import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../../css/message-popup.scss';

function MessagePopup(props) {

    return (
        <div>
            <Modal className='message-modal' show={true} backdrop="static">
                <Modal.Body>
                    <p>Please allow to access your location.</p>
                    <button className='close-button' onClick={() => props.setShowLocationError(false)}>
                        Close
                    </button>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default MessagePopup;